import React from 'react';
import {observer} from 'mobx-react';
import {MatchEventsModuleEventDetails} from "../event/match-events-module.event.details";
import {MatchEventsModuleStageTime} from "./match-events-module.stage.time";

export const MatchEventsModuleStageRow = observer(({row, stage, controller, isLast}) => {
  const {isPenalties} = stage;
  const {homeEvent, awayEvent, isNewEvent} = row;

  const matchEventsEventDetailsProps = {
    controller,
    isPenalties,
  };

  const homeEventProps = {
    event: homeEvent,
    positionDown: isPenalties && (awayEvent ? homeEvent.order < awayEvent.order : true),
    ...matchEventsEventDetailsProps
  };

  const awayEventProps = {
    event: awayEvent,
    positionDown: isPenalties && !(homeEvent ? homeEvent.order < awayEvent.order : true),
    swapDirection: true,
    ...matchEventsEventDetailsProps
  };

  const matchEventsTableTimeProps = {
    row,
    isLast,
    isPenalties,
  };

  const rowContainerClassName = ['match-event-module-stage-row-container',
    isPenalties ? 'match-event-module-stage-row-penalty-container' : '',
    isNewEvent ? 'match-event-module-animation' : '',
  ].join(' ');

  return (
    <div className={rowContainerClassName}>
      <div className={'match-event-module-stage-row-event-container'}>
        {
          homeEvent ? <MatchEventsModuleEventDetails {...homeEventProps}/> : null
        }
      </div>
      <div className={['match-event-module-stage-row-time-and-penalty-container', !isPenalties ? 'match-event-module-stage-row-time-and-penalty-container-animation' : ''].join(' ')}>
        <MatchEventsModuleStageTime {...matchEventsTableTimeProps}/>
      </div>
      <div className={'match-event-module-stage-row-event-container'}>
        {
          awayEvent ? <MatchEventsModuleEventDetails {...awayEventProps} /> : null
        }
      </div>
    </div>
  )
});